import { IAppState } from '../../../AppModulesWrapper';

import { ICheckoutDetail } from '../../types/reducers/checkoutInfo';

export function selectCheckoutDetails(state: IAppState): Array<ICheckoutDetail> {
  return state.servicePickerWidget.checkoutInfo.details;
}
